import { Loading3QuartersOutlined } from '@ant-design/icons';
import { Card, Spin } from 'antd';
import styled from 'styled-components';

const LoadingCard = styled(Card)`
  box-shadow: ${props => props.theme.boxShadowTailwindMd};
  border: 1px solid ${props => props.theme.colorSplit};
  margin-bottom: 24px;
  border-radius: 8px;

  > .ant-card-body {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 240px;
  }
`;

/**
 * Placeholder di caricamento per il sistema ConfigurationCard: una card vuota
 * con spinner centrato, resa da `ConfigurationCardGroup` al posto dei children
 * durante il primo caricamento (`loading`). Non si registra nel context, quindi
 * non compare nell'Anchor.
 */
export function ConfigurationCardLoading() {
  return (
    <LoadingCard bordered>
      <Spin size="large" indicator={<Loading3QuartersOutlined spin />} />
    </LoadingCard>
  );
}
